/* ===========================================================================
 * CART ADD-ON TOGGLE — VERSÃO PORTÁVEL
 * ---------------------------------------------------------------------------
 * Funciona em qualquer tema Online Store 2.0 sem saber o nome da section
 * do drawer. Estratégia em camadas:
 *
 *   1. Descobre o(s) #shopify-section-* que contém(êm) o componente e o
 *      contador do carrinho, subindo o DOM.
 *   2. POST /cart/update.js pedindo essas sections de volta (Section
 *      Rendering API — nativa da Shopify, não do tema).
 *   3. Troca o innerHTML dessas sections pelo HTML retornado.
 *   4. Dispara os eventos de carrinho das convenções mais comuns, pra que
 *      outras partes do tema (contador, barra de frete grátis) reajam.
 *   5. Se nada disso for possível, recarrega a página (fallback burro,
 *      mas nunca deixa a UI mentindo sobre o estado do carrinho).
 * ========================================================================= */
(function () {
  'use strict';

  if (window.customElements && customElements.get('cart-addon-toggle')) return;

  /* Rota do carrinho: cobre Dawn (window.routes), Focal/Maestrooo
     (window.themeVariables) e cai no padrão da Shopify. */
  function cartUrl() {
    var r = window.routes && (window.routes.cart_url || window.routes.cartUrl);
    if (r) return r;
    try {
      if (window.themeVariables.routes.cartUrl) return window.themeVariables.routes.cartUrl;
    } catch (e) { /* noop */ }
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/') .replace(/\/$/, '') + '/cart';
  }

  /* Extrai o id da section (sem o prefixo) a partir de um elemento. */
  function sectionIdOf(el) {
    var wrapper = el && el.closest ? el.closest('[id^="shopify-section-"]') : null;
    return wrapper ? wrapper.id.replace('shopify-section-', '') : null;
  }

  /* Tenta achar o wrapper da section que contém o contador do carrinho.
     Cobre as classes/ids mais comuns entre temas. Se não achar, tudo bem —
     os eventos disparados no passo 4 costumam dar conta. */
  var COUNT_SELECTORS = [
    '#cart-icon-bubble', '.cart-count-bubble', '[data-cart-count]',
    '.cart-count', '.header__cart-count', '[data-header-cart-count]'
  ];

  function countSectionId() {
    for (var i = 0; i < COUNT_SELECTORS.length; i++) {
      var node = document.querySelector(COUNT_SELECTORS[i]);
      var id = sectionIdOf(node);
      if (id) return id;
    }
    return null;
  }

  /* Substitui o conteúdo de uma section pelo HTML retornado pela API. */
  function swapSection(id, html) {
    var target = document.getElementById('shopify-section-' + id);
    if (!target || !html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var incoming = doc.getElementById('shopify-section-' + id);
    target.innerHTML = incoming ? incoming.innerHTML : html;
    return true;
  }

  /* Dispara os eventos de carrinho das convenções mais comuns. Temas que não
     escutam simplesmente ignoram — não há custo em disparar todos. */
  function broadcast(cart) {
    var detail = { cart: cart, replacementDelay: 0, source: 'cart-addon-toggle' };

    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(function (name) {
      document.documentElement.dispatchEvent(
        new CustomEvent(name, { bubbles: true, detail: detail })
      );
    });

    /* Dawn e derivados usam um pub/sub interno. Só chamamos se existir. */
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, detail);
      }
    } catch (e) { /* noop */ }
  }

  class CartAddonToggle extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.ca__input');
      if (!this.input || this._bound) return;
      this._bound = true;
      this.input.addEventListener('change', this._onChange.bind(this));
    }

    async _onChange() {
      if (this.classList.contains('is-loading')) return;

      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;

      var desired = this.input.checked ? 1 : 0;

      /* Guarda os ids ANTES do fetch — depois do swap o elemento pode
         não existir mais. */
      var mySection = sectionIdOf(this);
      var countSection = countSectionId();
      var sections = [mySection, countSection].filter(function (v, i, a) {
        return v && a.indexOf(v) === i;
      });

      this.classList.add('is-loading');
      this.input.disabled = true;

      try {
        var body = {
          updates: {},
          sections_url: window.location.pathname
        };
        body.updates[variantId] = desired;
        if (sections.length) body.sections = sections;

        var response = await fetch(cartUrl() + '/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });

        if (!response.ok) throw new Error('cart update falhou: ' + response.status);

        var cart = await response.json();

        broadcast(cart);

        /* Focal (este tema): o próprio tema re-renderiza o drawer ao receber
           "cart:refresh" e mantém ele ABERTO. Trocar o HTML da section na mão
           recriava o drawer fechado — por isso paramos aqui. */
        if (window.themeVariables) {
          var me = this;
          setTimeout(function () {
            if (!me.isConnected) return;
            me.classList.toggle('is-on', desired === 1);
            me.classList.remove('is-loading');
            me.input.disabled = false;
          }, 2500);
          return;
        }

        /* Se o tema não re-renderizou sozinho via eventos, fazemos o swap.
           Damos um respiro de um frame pro tema agir primeiro. */
        var self = this;
        requestAnimationFrame(function () {
          if (!self.isConnected) return; /* o tema já trocou o HTML: nada a fazer */

          var swapped = false;
          if (cart.sections) {
            sections.forEach(function (id) {
              if (swapSection(id, cart.sections[id])) swapped = true;
            });
          }

          if (!swapped) {
            /* Último recurso: sincroniza o visual localmente e avisa. */
            self.classList.toggle('is-on', desired === 1);
            self.classList.remove('is-loading');
            self.input.disabled = false;
            console.warn('[cart-addon-toggle] Section rendering indisponível — ' +
              'o restante do drawer pode estar desatualizado.');
          }
        });
      } catch (error) {
        this.input.checked = !this.input.checked;
        this.input.disabled = false;
        this.classList.remove('is-loading');
        console.error('[cart-addon-toggle]', error);
      }
    }
  }

  if (window.customElements) {
    customElements.define('cart-addon-toggle', CartAddonToggle);
  }
})();
